<template>
  <div>
    <!-- 直销统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>分销统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <div class="title_box" v-if="activeIndex!=3">
        <span>日期：</span>
        <el-date-picker
          v-model="data.Times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select v-model="data.DistributorID" clearable filterable placeholder="全部分销商" >
            <el-option
              v-for="item in disoption"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID"
            ></el-option>
        </el-select>
        <el-select v-if="GetChannelFlow"  v-model="data.channelCode" clearable filterable placeholder="渠道商" >
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>
        <span>展示内容：</span>
        <el-select v-model="data.type" placeholder="每日" v-if="!GetChannelFlow">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
        <el-select v-model="data.type" @change="selectTabs"     placeholder="每日" v-if="GetChannelFlow&&activeIndex!=1">
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
        <el-select v-model="data.type"  @change="selectTabs"  placeholder="每日" v-if="GetChannelFlow&&activeIndex==1">
            <el-option
              v-for="item in optionss"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
        </el-select>
        <el-select v-model="data.productid" clearable filterable  placeholder="全部产品" v-if="data.type=='2'">
            <el-option
              v-for="item in proDuctOption"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID"
            ></el-option>
        </el-select>
        <div class="chaxuns" @click="chaxun">查询</div>
        <div class="chaxuns" style="margin-left:2rem;" @click="exportRoute">去导出</div>
        <div class="chaxuns" style="margin-left:2rem;" @click="detailsClick">查询明细</div>
    </div>
    <div class="statistics" v-if="activeIndex==0">
        <div v-for="(item,index) in distri" :key="index">
          <div class="tics_title">
            <span>{{ item.text }}</span>
            <span>{{index=='0'?'退票总数量':'退票总金额'}}</span>
          </div>
          <div class="tics_imgs">
            <div>
              <span>{{ item.num }}</span>
              <span>{{ item.suffix }}</span>
            </div>
            <img :src="item.img" alt="">
          </div>
        </div>
    </div>
    <div class="statistics" v-if="activeIndex==1">
        <div v-for="(item,index) in distri" :key="index">
          <div class="tics_title">
            <span>{{ item.text }}</span>
            <span>{{index=='0'?'消费总数量':'消费总金额'}}</span>
          </div>
          <div class="tics_imgs">
            <div>
              <span>{{ item.num }}</span>
              <span>{{ item.suffix }}</span>
            </div>
            <img :src="item.img" alt="">
          </div>
        </div>
    </div>
    <div class="statistics" v-if="activeIndex==2">
        <div v-for="(item,index) in distri" :key="index">
          <div class="tics_title">
            <span>{{ item.text }}</span>
            <span>{{index=='0'?'销售总数量':'销售总金额'}}</span>
          </div>
          <div class="tics_imgs">
            <div>
              <span>{{ item.num }}</span>
              <span>{{ item.suffix }}</span>
            </div>
            <img :src="item.img" alt="">
          </div>
        </div>
    </div>
    <el-card class="conentBox" v-if="activeIndex==3">
      <div style="font-size:1.6rem;color:red;">本列表以游玩时间节点统计</div>
      <el-row class="conentRow">
        <div>
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="calendarProductID" clearable filterable placeholder="全部产品" style="margin-left: 1rem; width: 20rem;">
            <el-option
              v-for="item in proDuctOption"
              :key="item.ProductID"
              :label="item.ProductName"
              :value="item.ProductID"
            ></el-option>
          </el-select>
          <el-select v-model="calendarDistributorID" clearable filterable placeholder="全部分销商" style="margin-left: 1rem; width: 20rem;">
            <el-option
              v-for="item in disoption"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID"
            ></el-option>
          </el-select>
          <el-button type="primary" plain @click="btns" style="margin-left: 1rem;">
              查询
          </el-button>
        </div>
        <div>
            <el-button type="primary" plain @click="addProFn()">
                导出
            </el-button>
        </div>
      </el-row>
      <span class="txts">预约时间统计数量 : {{orderNum}}</span>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        v-loading="loading"
        :cell-style="cellStyle">
        <el-table-column prop="ScenicID" label="景区ID" ></el-table-column>
        <el-table-column  label="产品名称" width="200">
            <template slot-scope="scope">
              <span>{{scope.row.OrderAll.productname}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="OrderNumber" label="订单编号" width="180"></el-table-column>
        <el-table-column prop="OrderCode" label="验证码" ></el-table-column>
        <el-table-column prop="Distributor_name" label="分销商" ></el-table-column>
        <el-table-column prop="ActFee" label="支付金额" ></el-table-column>
        <el-table-column prop="Mobile" label="手机号" ></el-table-column>
        <el-table-column prop="CreateTime" label="下单时间" width="160"></el-table-column>
        <el-table-column prop="playdate" label="游玩日期" ></el-table-column>
        <el-table-column prop="Count" label="下单数量" ></el-table-column>
        <el-table-column prop="UseCount" label="使用数量" ></el-table-column>
        <el-table-column prop="CancleCount" label="退款数量" ></el-table-column>
        <el-table-column  label="是否可退" >
            <template slot-scope="scope">
              <span>{{scope.row.returnflag=='1'?'不可退':'可退'}}</span>
            </template>
        </el-table-column>
        
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{dataes.total}}条记录，</span>
        <span class="demonstration">当前显示第{{dataes.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="dataes.total" :current-page="dataes.page"  @current-change="currenchangedate" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-card v-else>
      <div v-if="activeIndex==0">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          
          style="width: 100%"
        >
          <el-table-column label="排序" type="index" ></el-table-column>
          <el-table-column prop="ProductName" label="产品名称" v-if="tableData.length!=0&&tableData[0].ProductName"></el-table-column>
          <el-table-column prop="UseTime" label="退票时间" v-if="tableData.length!=0&&!tableData[0].ProductName"></el-table-column>
          <el-table-column prop="total_Price" label="退票总金额" ></el-table-column>
          <el-table-column prop="total_use" label="退票数量" ></el-table-column>
          <el-table-column prop="address" label="操作" style="text-align:right;"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="seeInfoFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="List"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计 -->
      <div v-if="activeIndex==1&&flows">
        <div v-if="data.type<=2&&flows">
          <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="ProductName" label="产品名称" v-if="tableData.length!=0&&tableData[0].ProductID"></el-table-column>
          <el-table-column prop="UseTime" label="消费时间" v-if="tableData.length!=0&&!tableData[0].ProductID"></el-table-column>
          <el-table-column prop="total_Price" label="总金额"></el-table-column>
          <el-table-column prop="total_use" label="数量"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="xftjDetailFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div v-if="data.type==3&&flows" v-loading="loadings">
            <div class="dis_boxs">
                <div class="dis_title">
                    <div>分销商名称</div>
                    <div>产品名称</div>
                    <div>单价(元)</div>
                    <div>已检数量</div>
                    <div>已检金额(元)</div>
                    <div>操作</div>
                </div>
                <div class="dis_content"   v-for="(item,index) in tableData" :key="index">
                    <div v-for="(itm,idx) in item" :key="idx">
                      <div  class="posmmm"   v-if="itm.idx==true">
                        <span>{{itm.disName}}</span>
                      </div>
                      <div v-else></div>
                      <div :class="[itm.num==true?'clssColor':'',idx==item.length-1?'mar':'']" >{{itm.num==true?'小计':itm.product_name}}</div>
                      <div>{{itm.num==true?'': itm.AgentPrice}}</div>
                      <div>{{itm.total_use}}</div>
                      <div>{{itm.total_Price}}</div>
                      <div style="color:#246deb;cursor: pointer;" @click="xftjDetailFn(itm)">
                        {{itm.num==true?'': '查看详情'}}</div>
                    </div>
                    <!-- <div >
                      <div></div>
                      <div>小计</div>
                      <div></div>
                      <div>{{item[index].total_use.total_use}}</div>
                      <div>{{item[index].list.total_Price}}</div>
                    </div> -->
                </div>
            </div>
        </div>
        <div v-if="data.type==4&&flows"  v-loading="loadings"> 
            <div class="dis_boxs">
                <div class="dis_title">
                    <div>渠道商名称</div>
                    <div>产品名称</div>
                    <div>单价(元)</div>
                    <div>已检数量</div>
                    <div>已检金额(元)</div>
                    <div>操作</div>
                </div>
                <div class="dis_content" v-for="(item,index) in tableData" :key="index">
                    <div v-for="(itm,idx) in item" :key="idx">
                      <div class="posmmm"  v-if="itm.idx==true">
                        <span>{{itm.channelName}}</span>
                        </div>
                      <div v-else></div>
                      <div :class="[itm.num==true?'clssColor':'',idx==item.length-1?'mar':'']" >{{itm.num==true?'小计':itm.product_name}}</div>
                      <div>{{itm.num==true?'': itm.AgentPrice}}</div>
                      <div>{{itm.total_use}}</div>
                      <div>{{itm.total_Price}}</div>
                      <div style="color:#246deb;cursor: pointer;" @click="xftjDetailFn(itm)">
                        {{itm.num==true?'': '查看详情'}}</div>
                    </div>
                    <!-- <div >
                      <div></div>
                      <div>小计</div>
                      <div></div>
                      <div>{{item[index].total_use.total_use}}</div>
                      <div>{{item[index].list.total_Price}}</div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 分页开始 -->
        <div class="pagination" v-if="data.type<=2">
          <span class="demonstration">共{{total2}}条记录，</span>
          <span class="demonstration">当前显示第{{data2.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total2" :page-size="data2.page_size" @current-change="List2"></el-pagination>
        </div>
   
        
        <!-- 分页结束 -->
      </div>
      <!-- 消费统计结束 -->
      <!-- 销售统计统计开始 -->
      <div v-if="activeIndex==2">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <!-- <el-table-column prop="distributor_name" label="分销商" v-if="tableData.length!=0&&tableData[0].product_name"></el-table-column> -->
          <el-table-column prop="product_name" label="产品名称" v-if="tableData.length!=0&&tableData[0].product_name"></el-table-column>
          <el-table-column prop="CreateTime" label="销售时间" v-if="tableData.length!=0&&!tableData[0].product_name">
            <template slot-scope="scope">
             {{scope.row.CreateTime.substr(0,10)}}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="销售额"></el-table-column>
          <el-table-column prop="Count" label="数量"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="detailTickFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total3}}条记录，</span>
          <span class="demonstration">当前显示第{{data3.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total3" :page-size="data3.page_size" @current-change="List3"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
  
     <!-- 销售统计查看详情开始 -->
     <directStaDialog :channelCode='data2.channelCode' v-if="xstjinfovisible" :times="times" :dis="data.DistributorID" :fuTimes="data.Times" :i="i" ref="xstjinfoDialog" :starttime="starttime"  :xstjinfoId="xstjinfoId" @seeInfoHandle="XsClose"></directStaDialog>
    <!-- 销售统计查看详情结束 -->
    <!-- 消费统计明细开始 -->
    <directStaDialog :channelCode="data3.channelCode" v-if="detailvisible" :times="times" :dis="data.DistributorID" :fuTimes="data.Times"  :i="i" :starttime="XFdate" :xftjinfoId="xftjinfoId"   ref="detailDialog" @XFInfoHandle="XFClose" ></directStaDialog>
    <!-- 消费统计明细结束 -->
    <!-- 退票统计明细开始 -->
    <directStaDialog :channelCode='data1.channelCode' v-if="refundTicketvisible" :dis="data.DistributorID" :times="times" :fuTimes="data.Times" :starttime="XFdate"  ref="refundTicketDialog" :Tprow="Tprow" @TpClose="TpClose"></directStaDialog>
    <!-- 退票统计明细结束 -->
  </div>
</template>

<script>
import directStaDialog from "./dialog/distributionDialog.vue";
import {DistributorIDTotalSales,DistributorRefundGeneralLedger,DistributorIDVerifiGeneralLedger, GetChannel ,
  ScenicDisRefundTJ,GetScenicList,DisProductRefundTotal,
  getScenicListDistrbutor,
  ScenicDisTicketTJ,DisProductVerifiTotal,
  ScenicDisSellTJ,ScenicDisSellOneTJ,cldOrderCount,cldOrderCountExport , distributorProductTJ ,  distributorProductTJData ,
  channelCodeProductTJ , channelCodeProductTJData} from '@/request/scenic.js'
export default {
  components: {
    directStaDialog
  },
  data() {
    return {
      loadings:true,
      flows:true,
      GetChannelFlow:false,
      opstatusan:[
      ],
      starttime:'',
      xftjinfoId:'',
      Tprow:'',
      xstjinfovisible:false,
      detailvisible:false,
      refundTicketvisible:false,
      distri:[
        {
          text:'全部分销商',
          num:'0',
          suffix:'单',
          img:require('../../../images/report/table.png')
        },
        {
          text:'全部分销商',
          num:'0',
          suffix:'元',
          img:require('../../../images/report/money.png')
        }
      ],
      proDuctOption:[],
      disoption:[
        {
          DistrbutorID:"a",
          Name:'景区直销'
        }
      ],
      tableData:[],
      tabBtn: [
        {
          id: 1,
          name: "退票统计"
        },
        {
          id: 2,
          name: "核销统计"
        },
        {
          id: 3,
          name: "销售统计"
        },
        {
          id: 4,
          name: "日历统计"
        },
      ],
      activeIndex: "0", // 选中tab
      data:{
        productid:'',
        Times:'',
        type:'1',
        DistributorID:'',
        channelCode:''
      },
      option:[
          {
            value:'1',
            label:'每日'
          },
          {
            value:'2',
            label:'产品'
          }
      ],
      optionss:[
          {
            value:'1',
            label:'每日'
          },
          {
            value:'2',
            label:'产品'
          },
          {
            value:'3',
            label:'分销商产品'
          },
          {
            value:'4',
            label:'渠道商产品'
          }
         
      ],
      total:0,
      data1:{
        start_date:'',
        end_date:'',
        page_size:10,
        page:1,
        DistributorID:'',
        token:window.sessionStorage.getItem('Token'),
        productid:'',
        channelCode:''
      },
      data2:{
        start_date:'',
        end_date:'',
        page_size:10,
        page:1,
        DistributorID:'',
        token:window.sessionStorage.getItem('Token'),
        productid:'',
        channelCode:''
      },
      total2:0,
      data3:{
        start_date:'',
        end_date:'',
        page_size:10,
        page:1,
        DistributorID:'',
        token:window.sessionStorage.getItem('Token'),
        productid:'',
        channelCode:''
      },
      total3:0,
      i:0,
      xstjinfoId:'',
      XFdate:'',
      times:[],
      dataes:{
        token:window.sessionStorage.getItem('Token'),
        start_time:'',
        end_time:'',
        page:1,
        page_size:8,
        total:0
      },
      orderNum:0,
      value1:'',
      calendarProductID:'',
      calendarDistributorID:'',
      disdata:{
        token:window.sessionStorage.getItem('Token'),
        start_date:'',
        end_date:'',
        page:1,
        page_size:6
      },
      resn:'',
      listcon:[],
      listchan:[]
    };
  },
  created(){
    if(window.sessionStorage.getItem('ScenicId')=='131'){
      this.GetChannelFlow = true
    }
    let datas = {
      token:window.sessionStorage.getItem('Token'),
    }
    GetChannel(datas).then(res=>{
      if(res.data.status=='ok'){
        this.opstatusan=res.data.result
      }
    })
    this.data1.start_date = this.GetDateStr(0)  + ' 00:00:00' //  '2020-01-01' // 
    this.data1.end_date = this.GetDateStr(0)  + ' 23:59:59'//  '2023-01-01' // this.GetDateStr(0)
    this.data.Times = [this.GetDateStr(0),this.GetDateStr(0)]
    this.getList()
    this.getNum('0')
    let data = {
      token:window.sessionStorage.getItem('Token'),
      page:1,
      page_size:999
    }
    GetScenicList(data).then(res=>{
      if(res.data.status=='ok'){
        this.proDuctOption = res.data.result.data
      }
    })
    getScenicListDistrbutor(data).then(res=>{
      if(res.data.status=='ok'){
        this.disoption = this.disoption.concat(res.data.result.data)
      }
    })
  },
  methods: {
    selectTabs(e){
      this.flows = false
    },
    btns(){
      this.loading = true
      if(this.value1){
        this.dataes.start_time = this.value1[0] 
        this.dataes.end_time = this.value1[1] 
      }else{
        this.dataes.start_time = ''
        this.dataes.end_time = ''
      }
      this.dataes.ProductID = this.calendarProductID || ''
      this.dataes.DistributorID = this.calendarDistributorID || ''
      this.dataes.total = 0
      this.dataes.page  = 1
      this.getListdate()
    },
       // 分页
     currenchangedate(e){
        this.dataes.page = e
        this.getListdate()
      },
     // 导出产品
     addProFn() {
      if(this.value1){
        this.dataes.start_time = this.value1[0] 
        this.dataes.end_time = this.value1[1] 
      }else{
        this.$message.error('请选择时间后导出')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        start_time:this.dataes.start_time ,
        end_time:this.dataes.end_time,
        ProductID:this.calendarProductID || '',
        DistributorID:this.calendarDistributorID || ''
      }
      cldOrderCountExport(data).then(res=>{
        if(res.data.rcode==200){
          window.location.href = res.data.result
        }
      })
    },
    exportRoute(){
      this.$router.push({
        name:'report',
        params:{
            id:1,
            data:this.data,
            index:this.activeIndex
        }
      })
    },
      // 退票统计明细
    detailTickFn(row) {
      if(this.data.type==2){
        this.times = this.data.Times
      }
      this.refundTicketvisible = true;
      this.Tprow = row
      this.$nextTick(() => {
        this.$refs.refundTicketDialog.detailTick(row);
      });
    },
     // 消费统计明细
     xftjDetailFn(row) {
      this.detailvisible = true;
      if(row.ProductID){
        this.xftjinfoId = row.ProductID
        this.XFdate = this.data.Times
      }else{
        this.XFdate = row.UseTime
      }
      this.i=1
      this.$nextTick(() => {
        this.$refs.detailDialog.Detail(row);
      });
    },
    seeInfoFn(row) {
      if(row.ProductID){
        this.xstjinfoId = row.ProductID
      }
      if(this.data.type=='2'){
        this.times = this.data.Times
      }
      this.i = 0
      this.starttime = row.UseTime
      this.xstjinfovisible = true;
      this.$nextTick(() => {
        this.$refs.xstjinfoDialog.seeInfo(row);
      });
    },
    getList3(){
      ScenicDisSellTJ(this.data3).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total3 = res.data.result.total
        }
      })
    },
    getProList3(){
      this.data3.ProductID = this.data3.productid
      ScenicDisSellOneTJ(this.data3).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total3 = res.data.result.total
          this.tableData.map(item=>{
            item.total_Price = item.price
            item.total_use = item.orderformUse
          })
          if(this.data.productid && this.tableData.length == 1 && this.activeIndex == 2){
            this.tableData[0].Count = this.distri[0].num
          }
        }
      })
    },
    getList2(){
      ScenicDisTicketTJ(this.data2).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total2 = res.data.result.total
        }
      })
    },
    getProList2(){
      // this.data2.starttime = this.data2.start_date 
      // this.data2.endtime = this.data2.end_date
      DisProductVerifiTotal(this.data2).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total2 = res.data.result.total
          this.tableData.map(item=>{
            item.total_Price = item.price
            item.total_use = item.orderformUse
          })
        }
      })
    },
    List3(e){
      this.data3.page = e
      if(this.data.type==1){
        this.getList3()
      }else{
        this.getProList3()
      }
    },
    List2(e){
      this.data2.page = e
      if(this.data.type==1){
        this.getList2()
      }else{
        this.getProList2()
      }
    },
    List(e){
      this.data1.page = e
      if(this.data.type==1){
        this.getList()
      }else{
        this.getProList()
      }
    },
    getList(){
      ScenicDisRefundTJ(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    getProList(){
      DisProductRefundTotal(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
          this.tableData.map(item=>{
            item.total_Price = item.price
            item.total_use = item.orderformUse
          })
        }
      })
    },
    getNum(e){
      // let data = {
      //   token:window.sessionStorage.getItem('Token'),
      // }
      if(e==0){
        DistributorRefundGeneralLedger(this.data1).then(res=>{
          if(res.data.status=='ok'){
            this.distri[0].num = res.data.result[0].orderformUse==null?0:res.data.result[0].orderformUse
            this.distri[1].num = res.data.result[0].CountPrice==null?0:res.data.result[0].CountPrice
          }else{
            this.distri[0].num = 0
            this.distri[1].num = 0
          }
        })
      }else if(e==1){
        DistributorIDVerifiGeneralLedger(this.data2).then(res=>{
          if(res.data.status=='ok'){
            this.distri[0].num = res.data.result[0].orderformUse==null?0:res.data.result[0].orderformUse
            this.distri[1].num = res.data.result[0].CountPrice==null?0:res.data.result[0].CountPrice
          }else{
            this.distri[0].num = 0
            this.distri[1].num = 0
          }
        })
      }else if(e==2){
        DistributorIDTotalSales(this.data3).then(res=>{
          if(res.data.status=='ok'){
            this.distri[0].num = res.data.result[0].count==null?0:res.data.result[0].count
            this.distri[1].num = res.data.result[0].ActFee==null?0:res.data.result[0].ActFee
          }else{
            this.distri[0].num = 0
            this.distri[1].num = 0
          }
        })
      }
    },
    tabTitle(index) {
      this.activeIndex = index
      this.data.type = '1'
      this.data.productid = ''
      this.data.DistributorID = ''
      this.data1.channelCode = ''
      this.data2.channelCode = ''
      this.data3.channelCode = ''
      this.data.channelCode = ''
      this.tableData = []
      if(index==0){
        this.data1.start_date =  this.GetDateStr(0)  + ' 00:00:00'//'2020-01-01' 
        this.data1.end_date = this.GetDateStr(0)  + ' 23:59:59'
        this.data.Times = [this.GetDateStr(0) ,this.GetDateStr(0) ]
        this.getList()
      }else if(index==1){
        this.data2.start_date = this.GetDateStr(0) + ' 00:00:00'//  this.GetDateStr(-1)
        this.data2.end_date = this.GetDateStr(0)  + ' 23:59:59'// this.GetDateStr(0)
        this.data.Times = [this.GetDateStr(0),this.GetDateStr(0)]
        this.getList2()
      }else if(index==2){
        this.data3.start_date = this.GetDateStr(0)+ ' 00:00:00' //  this.GetDateStr(-1)
        this.data3.end_date = this.GetDateStr(0) + ' 23:59:59' // this.GetDateStr(0)
        this.data.Times = [this.GetDateStr(0),this.GetDateStr(0)]
        this.getList3()
      }else{
          this.value1 = [this.getTodayTime(),this.getTodayTime()]
          this.calendarProductID = ''
          this.calendarDistributorID = ''
          if(this.value1){
            this.dataes.start_time = this.value1[0] 
            this.dataes.end_time = this.value1[1] 
          }else{
            this.dataes.start_time = ''
            this.dataes.end_time = ''
          }
          this.getListdate()
      }
      this.getNum(index)
    },
    getTodayTime() {
      var day = new Date();
      let seconds = day.getSeconds();
      if (seconds < 10) { // 如果月份值小于10，则在前面加上0
        seconds = "0" + seconds;
      } else {
        seconds = seconds;
      }
      let minutes = day.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      } else {
        minutes = minutes;
      }
      let month = day.getMonth()
      if (month < 10) {
      month = "0" + month;
      }
      let time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() 
      return time
    },
    getListdate(){
      cldOrderCount(this.dataes).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.order.data
          this.dataes.total = res.data.result.order.total
          this.orderNum = res.data.result.order_num[0].order_num
          this.loading = false
        }
      })
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth()+1;//获取当前月份的日期
      var d = dd.getDate();
      m = (m > 9) ? m : ("0" + m);
      d = (d < 10) ? ("0" + d) : d;
      return y+"-"+m+"-"+d;
    },
    detailsClick(){
      if(this.activeIndex==0){
        this.times = this.data.Times
        let row = {
          UseTime : this.data.Times
        }
        if(this.data.type=='2'){
          this.xstjinfoId= this.data.productid
        }else{
          this.xstjinfoId = ''
        }
        this.xstjinfovisible = true;
        this.$nextTick(() => {
          this.$refs.xstjinfoDialog.seeInfo(row);
        });
      }else if(this.activeIndex==1){
        this.detailvisible = true;
        this.XFdate = this.data.Times
        if(this.data.type=='2'){
          this.xftjinfoId = this.data.productid
        }else{
          this.xftjinfoId = ''
        }
        this.i=1
        this.$nextTick(() => {
          this.$refs.detailDialog.Detail();
        });
      }else if(this.activeIndex==2){
        this.times = this.data.Times
        this.refundTicketvisible = true;
        let row = {
          ProductID:this.data.type=='2'?this.data.productid:'',
          CreateTime:this.data.Times,
          statetype:'1'
        }
        this.Tprow = row
        this.$nextTick(() => {
          this.$refs.refundTicketDialog.detailTick(row);
        });
      }
    },
    chaxun(){
      if(!this.data.Times){
        this.$message.error('请选择时间')
        return false
      }
      if(this.activeIndex==0){
        this.data1.DistributorID = this.data.DistributorID
        this.data1.productid = this.data.productid
        this.data1.page = 1
        this.total = 0
        this.data1.start_date = this.data.Times[0]  + ' 00:00:00'
        this.data1.end_date = this.data.Times[1]  + ' 23:59:59'
        this.tableData = []
        this.data1.channelCode = this.data.channelCode
        console.log(this.data.type)
        if(this.data.type=='1'){
            this.getList()
        }else{
          this.getProList()
        }
      }else if(this.activeIndex==1){
        this.data2.DistributorID = this.data.DistributorID
        this.data2.productid = this.data.productid
        this.data2.page = 1
        this.total2 = 0
        this.data2.start_date = this.data.Times[0]  + ' 00:00:00'
        this.data2.end_date = this.data.Times[1] + ' 23:59:59'
        this.data2.channelCode = this.data.channelCode
        this.tableData = []
        if(this.data.type=='1'){
          this.getList2()
          this.flows = true
        }else if(this.data.type=='2'){
          this.getProList2()
          this.flows = true
        }else if(this.data.type=='3'){
          this.loadings = true
          this.getDisList()
          this.flows = true
        }else if(this.data.type=='4'){
          this.loadings = true
          this.getDisList1()
          this.flows = true
        }
      }else if(this.activeIndex==2){
        this.data3.DistributorID = this.data.DistributorID
        this.data3.productid = this.data.productid
        this.data3.page = 1
        this.total3 = 0
        this.data3.start_date = this.data.Times[0] + ' 00:00:00'
        this.data3.end_date = this.data.Times[1] + ' 23:59:59'
        this.data3.channelCode = this.data.channelCode
        this.tableData = []
        console.log(this.data.type)
        if(this.data.type=='1'){
            this.getList3()
        }else{
          this.getProList3()
        }
      }
      this.getNum(this.activeIndex)
    },
    List4(e){
      this.disdata.page = e
      this.getDisList()
    },
    getDisList1(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          start_date:'',
          end_date:'',
          channelCode:this.data.channelCode
        }
        if(this.data.Times){
          data.start_date = this.data.Times[0] 
          data.end_date = this.data.Times[1] 
        }else{
          data.start_date = ''
          data.end_date = ''
        }
        channelCodeProductTJ(data).then(res=>{
          if(res.data.status=='ok'){
            this.listchan = res.data.result
            channelCodeProductTJData(data).then(resn=>{
                  this.tableData = []
                  this.resn = resn.data.result
                  this.lists1()
              })
          }
        })
    },
    lists1(){
      this.resn.map(itm=>{
        let arr = []
        this.listchan.map(item=>{
          if(item.channelName==itm.channelName){
            item.list = itm
            arr.push(item)
          }
        })
        if(arr.length!=0){
          this.tableData.push(arr)
        }
      })
      for(let i=0;i<this.tableData.length;i++){
          let num = 0
          for(let j=0;j<this.tableData[i].length;j++){
              for(let k=0;k<this.resn.length;k++){
                if(this.tableData[i][j].channelName==this.resn[k].channelName){
                  num += Number(this.tableData[i][j].total_Price)
                  this.resn[k].nums = num.toFixed(2)
                }
              }
          }              
      }

      for(let k=0;k<this.tableData.length;k++){
        this.tableData.map(itm=>{
          // itm
        })
        if(this.resn[k].nums==this.resn[k].total_Price){
            this.resn[k].num = true
            this.resn[k].idx = true
            this.tableData[k].push(this.resn[k])
        }
      }
      this.loadings = false
    },
    getDisList(){
      if(this.data.Times){
        this.disdata.start_date = this.data.Times[0] 
        this.disdata.end_date = this.data.Times[1] 
      }else{
        this.disdata.start_date = ''
        this.disdata.end_date = ''
      }
      distributorProductTJ(this.disdata).then(res=>{
        if(res.data.status=='ok'){
            this.listcon  = res.data.result
              distributorProductTJData(this.disdata).then(resn=>{
                  this.tableData = []
                  this.resn = resn.data.result
                  this.lists()
              })
        }
      })
    },
    lists(){
      this.resn.map(itm=>{
        let arr = []
        this.listcon.map(item=>{
          if(item.DistributorID==itm.DistributorID){
            item.list = itm
            arr.push(item)
          }
        })
        if(arr.length!=0){
          this.tableData.push(arr)
        }
      })
      for(let i=0;i<this.tableData.length;i++){
          let num = 0
          for(let j=0;j<this.tableData[i].length;j++){
              for(let k=0;k<this.resn.length;k++){
                if(this.tableData[i][j].DistributorID==this.resn[k].DistributorID){
                  num += Number(this.tableData[i][j].total_Price)
                  this.resn[k].nums = num.toFixed(2)
                }
              }
          }              
      }

      for(let k=0;k<this.tableData.length;k++){
        this.tableData.map(itm=>{
          // itm
        })
        if(this.resn[k].nums==this.resn[k].total_Price){
            this.resn[k].num = true
            this.resn[k].idx = true
            this.tableData[k].push(this.resn[k])
        }
      }
      this.loadings = false
    },
     // 关闭退票统计
     XsClose(){
      this.xstjinfoId = ''
      this.xstjinfovisible = false
    },
    XFClose(){
      this.detailvisible = false;
      this.XFdate = ''
      this.xftjinfoId = ''
    },
     TpClose(){
      this.refundTicketvisible = false;
      this.Tprow = ''
    },
  }
};
</script>

<style lang='less' scoped>
.dis_boxs{
  width: 100%;
  .dis_title{
    width: 100%;
    height: 5rem;
    background: #F7F7FA;
    display: flex;
    >div{
      text-align: center;
      line-height: 5rem;
      color: #000000;
      font-size: 1.4rem;
      width: 26rem;
      border-left:1px solid #CFCFD4;
      &:nth-child(2){
        width: 54.8rem;
        
      }
    }
  }
  .dis_content{
    width: 100%;
    position: relative;
    min-height: 5rem;
    &:nth-child(n+2){
      border-top: 1px solid #CFCFD4;
    }
    >div{
      display: flex;
      width: 100%;
      min-height: 5rem;
      >div{
        color: #333;
        font-size: 1.8rem;
        width: 26rem;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        &:nth-child(2){
          width: 54.8rem;
        }
        &:nth-child(n+2){
          border-left:1px solid #CFCFD4;
          border-bottom: 1px solid #CFCFD4;
        }
      }
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    cursor: pointer;
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
.title_box{
  width: 100%;
  background: #fff;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /deep/.el-select{
    margin-right: 1rem;
    width:22rem;
  }
  /deep/.el-date-editor{
    margin-right: 2rem;
    width:28rem;
  }
  span{
    color: #666;
  }
}
.chaxuns{
  width: 10rem;
  height: 4rem;
  border-radius: 0.4rem;
  background: #246DEB;
  color: #fff;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.statistics{
  margin: 2rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  >div{
    position: relative;
    width: 39rem;
    height: 15rem;
    border-radius: 0.4rem;
    background: #fff;
    margin-right: 2rem;
    padding: 1.7rem 2rem;
    box-sizing: border-box;
    .tics_title{
      display: flex;
      align-items: center;
      span{
        color: #333;
        font-size: 1.4rem;
        &:nth-child(1){
          font-family: OPPOSans;
        }
        &:nth-child(2){
          color: #666666;
          margin-left: 0.3rem;
        }
      }
    }
    .tics_imgs{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 3.7rem;
      img{
        width: 5.4rem;
        height: 6rem;
      }
      div{
         span{
          color: #246DEB;
          font-size: 4rem;
          &:nth-child(1){
            font-family: OPPOSans;
          }
          &:last-child{
            color: #797979;
            font-size: 2rem;
            margin-left: 0.9rem;
          }
         }
      }
    }
  }
}
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  .conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    >div{
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      ::v-deep .el-button{
        height: 4rem;
        margin-left: 2rem;
        background: #246DEB;
        color: #fff;
      }
      
    }
  }
}
.txts{
  margin-bottom: 2rem;
  color: red;
  font-size: 1.6rem;
}
.clssColor{
  background: #F7F7FA;
  // margin-left: 22.2rem;
}
.posmmm{
  position: relative;
  span{
    display: block;
    position: absolute;
    top: -30%;
    transform: translate(0,-50%);
  }
}
</style>